import {
  AuthenticationInformationResponse,
  getAuthenticationInformationQueryKey,
} from "../api/endpoint.js";
import { useQueryClient } from "@tanstack/react-query";

type Methods = "Password" | "Mfa" | "Passkey";

/**
 * A hook that provides utilities for managing security settings.
 * Allows optimistically updating verification method status (password, MFA, passkey)
 * while also triggering a server revalidation.
 */
export function useSecuritySettings() {
  const client = useQueryClient();

  const update = (method: Methods, isSetUp: boolean) => {
    const queryKey = getAuthenticationInformationQueryKey();

    // Optimistic update
    client.setQueriesData<AuthenticationInformationResponse>(
      { queryKey, exact: false },
      (data) => {
        if (!data) {
          return data;
        }

        return {
          ...data,
          data: {
            ...data.data,
            verificationMethods: {
              ...data.data.verificationMethods,
              [method]: { ...data.data.verificationMethods[method], isSetUp },
            },
          },
        };
      },
    );

    // Also validate it with the server
    client.invalidateQueries({
      queryKey: getAuthenticationInformationQueryKey(),
      exact: false,
    });
  };

  return { update };
}
